/* eslint-disable operator-linebreak */
import { createAction } from "@reduxjs/toolkit";
import { IDownloadDocumentRequest, IDocumentDownload } from "app/interfaces/document-download/document-download.interface";
import { IBulkMarketplaceList, IBulkSummaryList, IMarketplaceList } from "app/interfaces/marketplace/marketplace.interface";
import { IPagination } from "../reducers/PortofolioReducer";
import { IBulkLoanNumberRequest, IBulkLoanNumberResponse } from "./FundingAction";

export const GET_MARKETPLACE_LIST = 'GET_MARKETPLACE_LIST';
export const SET_MARKETPLACE_LIST = 'SET_MARKETPLACE_LIST';
export const RESET_MARKETPLACE_LIST = 'RESET_MARKETPLACE_LIST';
export const MARKETPLACE_DOWNLOAD_FACTSHEET = 'MARKETPLACE_DOWNLOAD_FACTSHEET';
export const MARKETPLACE_SET_FACTSHEET = 'MARKETPLACE_SET_FACTSHEET';
export const RESET_MARKETPLACE_FACTSHEET = 'RESET_MARKETPLACE_FACTSHEET';
export const GET_BULK_MARKETPLACE_LIST = 'GET_BULK_MARKETPLACE_LIST';
export const SET_BULK_MARKETPLACE_LIST = 'SET_BULK_MARKETPLACE_LIST';
export const GET_BULK_SUMMARY_LIST = 'GET_BULK_SUMMARY_LIST';
export const SET_BULK_SUMMARY_LIST = 'SET_BULK_SUMMARY_LIST';
export const GET_TNC_PRIVACY_POLICY = 'GET_TNC_PRIVACY_POLICY';
export const SET_TNC_PRIVACY_POLICY = 'SET_TNC_PRIVACY_POLICY';
export const GET_BULK_LOAN_NUMBER = 'GET_BULK_LOAN_NUMBER';
export const SET_BULK_LOAN_NUMBER = 'SET_BULK_LOAN_NUMBER';

export interface IMarketplaceListResponse {
    marketplaceList: IMarketplaceList[];
    pagination: IPagination;
}

export interface IMarketplaceListRequest {
    page: number;
	limit: number;
	flag: string;
	loanTypeId?: string;
	tenor?: number | string;
}

export interface IBulkMarketplaceListRequest {
    page: number;
	limit: number;
}

export interface IBulkMarketplaceListResponse {
    bulkList: IBulkMarketplaceList[];
	isBulkFunding: boolean;
    pagination: IPagination;
}

export interface ITncPrivacyPolicyRequest {
    category: string;
	key: string;
}

export interface DetailTncPrivacyPolicy {
	category: string;
	key: string;
	description: string;
}

export interface IBulkSummaryListRequest {
    page: number;
	limit: number;
	flag: string;
	bulk_secure_id: string;
}

export interface IBulkSummaryListResponse {
    bulkSummaryList: IBulkSummaryList[];
    pagination: IPagination;
}

export const getMarketplaceListAction =
    createAction<IMarketplaceListRequest>(
		GET_MARKETPLACE_LIST
	);
export const setMarketplaceListAction =
    createAction<IMarketplaceListResponse>(
		SET_MARKETPLACE_LIST
	);
export const resetMarketplaceListAction =
    createAction(
		RESET_MARKETPLACE_LIST
	);
export const marketplaceDownloadFactsheetAction =
    createAction<IDownloadDocumentRequest>(
		MARKETPLACE_DOWNLOAD_FACTSHEET
	);
export const marketplaceSetFactsheetAction =
    createAction<IDocumentDownload>(
		MARKETPLACE_SET_FACTSHEET
	);
export const resetMarketplaceFactsheetAction =
    createAction(
		RESET_MARKETPLACE_FACTSHEET
	);
export const getTNCPrivacyPolicy =
	createAction<ITncPrivacyPolicyRequest>(
		GET_TNC_PRIVACY_POLICY
	);
export const setTNCPrivacyPolicy =
	createAction<DetailTncPrivacyPolicy[]>(
		SET_TNC_PRIVACY_POLICY
	);
export const getBulkMarketplaceList =
	createAction<IBulkMarketplaceListRequest>(
		GET_BULK_MARKETPLACE_LIST
	);
export const setBulkMarketplaceList =
	createAction<IBulkMarketplaceListResponse>(
		SET_BULK_MARKETPLACE_LIST
	);
export const getBulkSummaryList =
	createAction<IBulkSummaryListRequest>(
		GET_BULK_SUMMARY_LIST
	);
export const setBulkSummaryList =
	createAction<IBulkSummaryListResponse>(
		SET_BULK_SUMMARY_LIST
	);
export const getBulkLoanNumberAction =
	createAction<IBulkLoanNumberRequest>(
		GET_BULK_LOAN_NUMBER
	);
export const setBulkLoanNumberAction =
	createAction<IBulkLoanNumberResponse[]>(
		SET_BULK_LOAN_NUMBER
	);
